export const mapDeploymentDurationIdToDurationLength = (rows) => {
    const map = {};
    rows.forEach((row) => (map[row.id] = row.columns.durationLength));
    return map;
};
